import { Injectable, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth } from 'firebase/app';
import { environment } from '@env';
import { HttpService } from './http.service';
import { UtilService } from './util.service';
import { Router } from '@angular/router';
import { errores } from '@app/lang/errores';

@Injectable()
export class AuthService {

	habilitarLogin = (environment[environment.alias[window.location.hostname]].firebase) ? false : true;

	constructor(
		private afAuth: AngularFireAuth,
		private httpService: HttpService,
		private utilService: UtilService,
		private ngZone: NgZone,
		private router: Router
	) {
		const sub = this.afAuth.user.subscribe((user: firebase.User) => {
			if (user) {
				this.utilService.notification('Welcome ' + user.displayName + ' Please log in again');
				console.log('sos', user);
				// Si lo queres correr haces  this.afAuth.auth.signOut();
			}
			sub.unsubscribe();
		});
	}

	login(provider: string) {
		switch (provider) {
			case 'google':
				this.afAuth.auth.signInWithPopup(new auth.GoogleAuthProvider()).then((credential: auth.UserCredential) => {
					credential.user.getIdToken(true).then((idToken) => {
						this.sendToken(idToken);
					});
				}).catch(error => {
					console.log('tengo err', error);
					this.utilService.notification(error.message);
				});
				break;
			case 'yahoo':
				const yahoo = new auth.OAuthProvider('yahoo.com');
				yahoo.addScope('sdpp-w');
				this.afAuth.auth.signInWithPopup(yahoo).then((credential: auth.UserCredential) => {
					credential.user.getIdToken(true).then((idToken) => {
						this.sendToken(idToken);
					});
				}).catch(error => {
					console.log('tengo err', error);
					this.utilService.notification(error.message);
				});
				break;
			case 'microsoft':
				this.afAuth.auth.signInWithPopup(new auth.OAuthProvider('microsoft.com')).then((credential: auth.UserCredential) => {
					credential.user.getIdToken(true).then((idToken) => {
						this.sendToken(idToken);
					});
				}).catch(error => {
					console.log('tengo err', error);
					this.utilService.notification(error.message);
				});
				break;
			case 'facebook':
				this.afAuth.auth.signInWithPopup(new auth.FacebookAuthProvider()).then((credential: auth.UserCredential) => {
					credential.user.getIdToken(true).then((idToken) => {
						this.sendToken(idToken);
					});
				}).catch(error => {
					console.log('tengo err', error);
					this.utilService.notification(error.message);
				});
				break;
			default:
				break;
		}
	}

	sendToken(idToken) {
		this.httpService.post('auth/veriLogin', { idToken }).then((data) => {
			if (data.success && data.logged) {
				this.utilService.setLS('logged', true);
				this.utilService.setLS('googleDrive', data.googleDrive, true);
				this.ngZone.run(() => {
					this.router.navigate(['/']);
				});
			} else {
				this.utilService.notification(errores[data.err]);
				this.utilService.setLS('logged', false);
			}
		});
	}
}
